import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth";

export function useOnboarding() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: onboardingDone, isLoading } = useQuery({
    queryKey: ["onboarding", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select("onboarding_done")
        .eq("user_id", user!.id)
        .single();
      if (error) throw error;
      return data.onboarding_done as boolean;
    },
    enabled: !!user,
  });

  const { mutate: completeOnboarding } = useMutation({
    mutationFn: async () => {
      const { error } = await supabase
        .from("profiles")
        .update({ onboarding_done: true } as any)
        .eq("user_id", user!.id);
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.setQueryData(["onboarding", user?.id], true);
    },
  });

  const { mutate: resetOnboarding } = useMutation({
    mutationFn: async () => {
      const { error } = await supabase
        .from("profiles")
        .update({ onboarding_done: false } as any)
        .eq("user_id", user!.id);
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.setQueryData(["onboarding", user?.id], false);
    },
  });

  return {
    showOnboarding: !isLoading && onboardingDone === false,
    completeOnboarding,
    resetOnboarding,
  };
}
